export const nameOfScammerData = {
  telephone: {
    title: 'What was the name of the company/organisation the caller said they were calling from?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
  },
  online: {
    title: 'What was the name of the company or organisation?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
  },
  email: {
    title: 'Name of the company/organisation the email appeared to be from',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
  },
  letter: {
    title: 'Name of the company/organisation the letter or flyer appeared to be from',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
  },
  textMessage: {
    title: 'Name of the company/organisation the text appeared to be from',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
  },
  social: {
    title: 'What was the name of the company/organisation the website appeared to be',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
  },
}
